import _ from 'lodash'
import {hasRole} from '../../helpers/user'

export const uccoCanCreate = (state) => {
  const status = _.get(state.updateCaseCreationOrder, 'data.status', null)
  const caseStatus = _.get(state.updateCaseCreationOrder, 'data.caseStatus', null)

  if (caseStatus === 'waitingForMaterials') {
    return false
  }

  return (hasRole(state.user, 'admin') || hasRole(state.user, 'clientadmin')) && _.includes(['validation', 'draft', 'declined', 'error'], status)
};

export const uccoCanSendToValidation = (state) => {
  const status = _.get(state.updateCaseCreationOrder, 'data.status', null)
  const caseStatus = _.get(state.updateCaseCreationOrder, 'data.caseStatus', null)

  if (caseStatus === 'waitingForMaterials') {
    return false
  }

  return !hasRole(state.user, 'admin') && !hasRole(state.user, 'clientadmin') && _.includes(['draft', 'declined', 'error'], status)
};

export const uccoCanUpdateAfterCreation = (state) => {
  const status = _.get(state.updateCaseCreationOrder, 'data.status', null)
  const caseStatus = _.get(state.updateCaseCreationOrder, 'data.caseStatus', null)

  if (caseStatus === 'waitingForMaterials' && !_.includes(['validation', 'sendingToDiagnostics', 'completed', 'canceled', 'diagnostics'], status)) {
    return true
  }

  return _.includes(['waitingForMaterials'], status)
};